module.exports = __webpack_public_path__ + "static/media/logo.dede4a8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 664
// module chunks = 0